import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { action, computed, makeObservable, observable } from 'mobx';
import { sum } from '../../utils/utils';

const leverageForm = {
  fields: {
    loanToCost: {
      value: 0,
      error: null,
      rule: '',
    },
    constructionReserve: {
      value: 0,
      error: null,
      rule: '',
    },
    initialAdvance: {
      value: 0,
      error: null,
      rule: '',
    },
    constructionHoldback: {
      value: 0,
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class LeverageFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(leverageForm, globalStore);
  }
}
